<template>
  <div>
    <v-row
      v-if="loading"
      class="fill-height"
      align-content="center"
      justify="center"
      dense
    >
      <v-col class="subtitle-1 text-center" cols="12">
        Getting user files
      </v-col>
      <v-col cols="8" sm="6">
        <v-progress-linear
          color="#1a4dcd"
          :active="loading"
          :indeterminate="loading"
          rounded
          height="4"
        ></v-progress-linear>
      </v-col>
    </v-row>
    <v-container v-if="!loading" class="mb-5">
      <InfoData :infos="infos" />
      <v-row align="center" justify="center" dense>
        <v-btn
          class="mt-5"
          v-if="!more"
          color="#1a4dcd"
          dark
          small
          rounded
          @click="more = true"
        >
          <b>See More</b>
          <v-icon> mdi-chevron-down </v-icon>
        </v-btn>
      </v-row>

      <InfoProduct
        v-if="more"
        :infos="infos"
        :products_seen="products_seen"
        :products_liked="products_liked"
        :products_ignored="products_ignored"
        :products_bookmarked="products_bookmarked"
      />
      <ProdToSent />
    </v-container>
    <v-btn
      v-scroll="onScroll"
      v-show="go_top"
      fab
      dark
      fixed
      bottom
      rigth
      color="#1141ce"
      @click="toTop"
    >
      <v-icon>mdi-arrow-up</v-icon>
    </v-btn>
  </div>
</template>

<script>
import InfoData from "./Info_data";
import InfoProduct from "./Info_products";
import ProdToSent from "./Bottom-sent";

export default {
  name: "Infos",
  data() {
    return {
      loading: false,
      more: false,
      fab: false,
      go_top: false,
      menu: false,
    };
  },
  mounted() {
    this.loading = true;
  },
  components: {
    InfoData,
    InfoProduct,
    ProdToSent,
  },
  watch: {
    loading(val) {
      if (!val) return;
      setTimeout(() => (this.loading = false), 500);
    },
  },
  props: {
    infos: {
      type: Object,
      default: () => {},
    },
    products_seen: {
      type: Array,
      default: () => [],
    },
    products_liked: {
      type: Array,
      default: () => [],
    },
    products_ignored: {
      type: Array,
      default: () => [],
    },
    products_bookmarked: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.go_top = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
};
</script>
